// Campo de contraseña con el ojo para mostrarla u ocultarla (decisión D51). Con guantes y sol conviene verla antes de
// tocar "Entrar": por eso el botón es grande y queda a mano, dentro del campo.
import { type CampoProps, cx, Icono } from '@reparto/ui';
import { useId, useState } from 'react';

export function CampoClave({
  etiqueta = 'Contraseña',
  error,
  ayuda,
  className,
  id,
  ...resto
}: Omit<CampoProps, 'type' | 'icono'>) {
  const [ver, setVer] = useState(false);
  const autoId = useId();
  const campoId = id ?? autoId;
  return (
    <div className={className}>
      <label htmlFor={campoId} className="mb-1.5 block text-xs font-medium text-stone-600 dark:text-stone-400">
        {etiqueta}
      </label>
      <div className="relative">
        <Icono nombre="lock" className="pointer-events-none absolute top-1/2 left-3 -translate-y-1/2 text-stone-400" />
        <input
          id={campoId}
          type={ver ? 'text' : 'password'}
          autoCapitalize="none"
          autoCorrect="off"
          spellCheck={false}
          aria-invalid={error ? true : undefined}
          aria-describedby={error || ayuda ? `${campoId}-ayuda` : undefined}
          className={cx(
            'h-12 w-full rounded-2xl border bg-white pr-14 pl-11 text-base text-stone-900 placeholder:text-stone-400',
            'focus:border-primary-500 focus:ring-2 focus:ring-primary-500/40 focus:outline-none',
            'dark:bg-stone-800 dark:text-stone-100',
            error ? 'border-rose-400' : 'border-stone-300 dark:border-stone-700',
          )}
          {...resto}
        />
        <button
          type="button"
          onClick={() => setVer((v) => !v)}
          aria-label={ver ? 'Ocultar la contraseña' : 'Mostrar la contraseña'}
          aria-pressed={ver}
          aria-controls={campoId}
          className="absolute top-1/2 right-0.5 grid h-11 w-12 -translate-y-1/2 place-items-center rounded-2xl text-stone-500 hover:text-stone-800 focus-visible:outline-2 focus-visible:outline-primary-500 dark:text-stone-400 dark:hover:text-stone-100"
        >
          <Icono nombre={ver ? 'visibility_off' : 'visibility'} />
        </button>
      </div>
      {error || ayuda ? (
        <p
          id={`${campoId}-ayuda`}
          className={cx(
            'mt-1 text-xs',
            error ? 'text-rose-600 dark:text-rose-300' : 'text-stone-500 dark:text-stone-400',
          )}
        >
          {error ?? ayuda}
        </p>
      ) : null}
    </div>
  );
}
